import { formatApiDateFromDate } from '@/utils/date';

/** The dates the account's transactions tab shows, in the API's format. */
export interface TransactionPeriod {
  startDate: string;
  endDate: string;
}

/** Legacy's default for an account's transactions: the month so far. */
export function defaultTransactionPeriod(): TransactionPeriod {
  const today = new Date();
  return {
    startDate: formatApiDateFromDate(
      new Date(today.getFullYear(), today.getMonth(), 1),
    ),
    endDate: formatApiDateFromDate(today),
  };
}
